import React from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const History = () => {
  // Sample history data
  const historyItems = [
    {
      id: 1,
      template: 'AI Ad Generator',
      productName: 'SmartWatch Pro',
      generatedAt: '2025-01-15 14:30',
      preview: 'Discover the future on your wrist with SmartWatch Pro. Advanced features meet elegant design...',
    },
    {
      id: 2,
      template: 'Social Media Posts',
      productName: 'Organic Coffee Beans',
      generatedAt: '2025-01-15 10:15',
      preview: 'Start your morning right! ☕ Our premium organic coffee beans are sourced from...',
    },
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <div className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-6 py-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Generation History</h1>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              {historyItems.length > 0 ? (
                <div className="divide-y divide-gray-200">
                  {historyItems.map((item) => (
                    <div key={item.id} className="p-6 hover:bg-gray-50 transition">
                      <div className="flex items-start justify-between mb-2">
                        <div>
                          <h3 className="text-lg font-semibold text-gray-900">{item.productName}</h3>
                          <p className="text-sm text-gray-500">Template: {item.template}</p>
                        </div>
                        <span className="text-sm text-gray-400">{item.generatedAt}</span>
                      </div>
                      <p className="text-gray-600 mb-4">{item.preview}</p>
                      <div className="flex space-x-3">
                        <button className="px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700">
                          View Full Content
                        </button>
                        <button className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-700">
                          Copy
                        </button>
                        <button className="px-4 py-2 text-sm font-medium text-red-600 hover:text-red-700">
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="p-12 text-center">
                  <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="mt-4 text-gray-500">No generation history yet</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
